// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/codebuild/output/src3512736026/src/app/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/PageLoading/index';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__Root' */'@/layouts/Root'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/login",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'@/layouts/UserLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "Login",
            "path": "/login",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account' */'/codebuild/output/src3512736026/src/app/src/pages/Account'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/login-success",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__SecurityLayout' */'@/layouts/SecurityLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "Login Success",
            "path": "/login-success",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__LoginSuccess' */'/codebuild/output/src3512736026/src/app/src/pages/Account/LoginSuccess'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/login-error",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'@/layouts/UserLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "Login Error",
            "path": "/login-error",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__LoginError' */'/codebuild/output/src3512736026/src/app/src/pages/Account/LoginError'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/session-expired",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'@/layouts/BlankLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "Session Expired",
            "path": "/session-expired",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__SessionExpired' */'/codebuild/output/src3512736026/src/app/src/pages/Account/SessionExpired'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/oauth/callback",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__SecurityLayout' */'@/layouts/SecurityLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "OAuth Callback",
            "path": "/oauth/callback",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__OAuthCallback' */'/codebuild/output/src3512736026/src/app/src/pages/OAuthCallback'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/account",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'@/layouts/UserLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "name": "Forgot Password",
            "path": "/account/forgot-password",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__Recover__ForgotPassword' */'/codebuild/output/src3512736026/src/app/src/pages/Account/Recover/ForgotPassword'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "First Login",
            "path": "/account/first-login",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__Recover__FirstLogin' */'/codebuild/output/src3512736026/src/app/src/pages/Account/Recover/FirstLogin'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "Reset Password",
            "path": "/account/reset-password",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__Recover__ResetPassword' */'/codebuild/output/src3512736026/src/app/src/pages/Account/Recover/ResetPassword'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "New Password",
            "path": "/account/new-password",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__Recover__NewPassword' */'/codebuild/output/src3512736026/src/app/src/pages/Account/Recover/NewPassword'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "Account Activation",
            "path": "/account/activation",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__Recover__components__AccountActivation' */'/codebuild/output/src3512736026/src/app/src/pages/Account/Recover/components/AccountActivation'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "Complete Profile",
            "path": "/account/complete-profile",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__CompleteProfile' */'/codebuild/output/src3512736026/src/app/src/pages/Account/CompleteProfile'), loading: LoadingComponent}),
            "authority": [
              "ADMIN",
              "EDITOR",
              "VIEWER"
            ],
            "exact": true
          },
          {
            "name": "Select Organization",
            "path": "/account/select-organization",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Account__SignIn__SelectOrganization' */'/codebuild/output/src3512736026/src/app/src/pages/Account/SignIn/SelectOrganization'), loading: LoadingComponent}),
            "authority": [
              "ADMIN",
              "EDITOR",
              "VIEWER"
            ],
            "exact": true
          }
        ]
      },
      {
        "path": "/:org/:ws/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__SecurityLayout' */'@/layouts/SecurityLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/:org/:ws/catalog/dataobjects",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'@/layouts/BlankLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "[Data Object Name]",
                "icon": "database",
                "path": "/:org/:ws/catalog/dataobjects/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Catalog__ViewDataObject' */'/codebuild/output/src3512736026/src/app/src/pages/Catalog/ViewDataObject'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/codebuild/output/src3512736026/src/app/src/pages/404'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "path": "/:org/:ws/hub/datasets",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'@/layouts/BlankLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "View Dataset",
                "icon": "database",
                "path": "/:org/:ws/hub/datasets/:id/view/:version",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Hub__ViewDataset' */'/codebuild/output/src3512736026/src/app/src/pages/Hub/ViewDataset'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__OwnerWorkspaceLayout' */'@/layouts/OwnerWorkspaceLayout'), loading: LoadingComponent}),
                "routes": [
                  {
                    "name": "Edit Dataset",
                    "icon": "code",
                    "path": "/:org/:ws/hub/datasets/:id/edit/:version",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Hub__EditDataset' */'/codebuild/output/src3512736026/src/app/src/pages/Hub/EditDataset'), loading: LoadingComponent}),
                    "authority": [
                      "ADMIN",
                      "EDITOR"
                    ],
                    "exact": true
                  },
                  {
                    "name": "View Dataset Test",
                    "icon": "database",
                    "path": "/:org/:ws/hub/datasets/test/:id/view/:version",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Hub__ViewDatasetTest' */'/codebuild/output/src3512736026/src/app/src/pages/Hub/ViewDatasetTest'), loading: LoadingComponent}),
                    "authority": [
                      "ADMIN",
                      "EDITOR"
                    ],
                    "exact": true
                  },
                  {
                    "name": "Edit Dataset Test",
                    "icon": "code",
                    "path": "/:org/:ws/hub/datasets/test/:id/edit/:version",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Hub__EditDatasetTest' */'/codebuild/output/src3512736026/src/app/src/pages/Hub/EditDatasetTest'), loading: LoadingComponent}),
                    "authority": [
                      "ADMIN",
                      "EDITOR"
                    ],
                    "exact": true
                  }
                ]
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/codebuild/output/src3512736026/src/app/src/pages/404'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "path": "/:org/:ws/flows/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'@/layouts/BlankLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "View Flow",
                "icon": "flow",
                "path": "/:org/:ws/flows/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Flows__ViewFlow__index' */'/codebuild/output/src3512736026/src/app/src/pages/Flows/ViewFlow/index'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/codebuild/output/src3512736026/src/app/src/pages/404'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "path": "/:org/:ws/integrations/add",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'@/layouts/BlankLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "Add integration",
                "path": "/:org/:ws/integrations/add",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Integrations__AddIntegration' */'/codebuild/output/src3512736026/src/app/src/pages/Integrations/AddIntegration'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN"
                ],
                "exact": true
              }
            ]
          },
          {
            "path": "/:org/:ws/ai-dashboard/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'@/layouts/BlankLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "AI Dashboard View",
                "path": "/:org/:ws/ai-dashboard/:id/view",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AiDashboard__View' */'/codebuild/output/src3512736026/src/app/src/pages/AiDashboard/View'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR",
                  "VIEWER"
                ],
                "exact": true
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/codebuild/output/src3512736026/src/app/src/pages/404'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "path": "/:org/:ws/dashboard/:id",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'@/layouts/BlankLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "Dashboard View",
                "path": "/:org/:ws/dashboard/:id/view",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dashboard__DashboardView' */'/codebuild/output/src3512736026/src/app/src/pages/Dashboard/DashboardView'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR",
                  "VIEWER"
                ],
                "exact": true
              },
              {
                "name": "Dashboard Edit",
                "path": "/:org/:ws/dashboard/:id/edit",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dashboard__DashboardEdit' */'/codebuild/output/src3512736026/src/app/src/pages/Dashboard/DashboardEdit'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/codebuild/output/src3512736026/src/app/src/pages/404'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "path": "/:org/:ws/settings/invoice",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'@/layouts/BlankLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "Invoice Download",
                "path": "/:org/:ws/settings/invoice/:invoiceId",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Settings__InvoiceRedirect' */'/codebuild/output/src3512736026/src/app/src/pages/Settings/InvoiceRedirect'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/codebuild/output/src3512736026/src/app/src/pages/404'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "path": "/:org/:ws/settings/portal",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'@/layouts/BlankLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "name": "Billing Portal",
                "path": "/:org/:ws/settings/portal",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Settings__PortalRedirect' */'/codebuild/output/src3512736026/src/app/src/pages/Settings/PortalRedirect'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              }
            ]
          },
          {
            "path": "/:org/:ws/",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicLayout' */'@/layouts/BasicLayout'), loading: LoadingComponent}),
            "routes": [
              {
                "path": "/:org/:ws/",
                "redirect": "/:org/:ws/assistant",
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              },
              {
                "name": "Home",
                "path": "/:org/:ws/home",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Home' */'/codebuild/output/src3512736026/src/app/src/pages/Home'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR",
                  "VIEWER"
                ],
                "exact": true
              },
              {
                "name": "Settings",
                "path": "/:org/:ws/settings",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Settings' */'/codebuild/output/src3512736026/src/app/src/pages/Settings'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              },
              {
                "name": "WorkspaceSettings",
                "path": "/:org/:ws/workspace-settings",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__WorkspaceSettings' */'/codebuild/output/src3512736026/src/app/src/pages/WorkspaceSettings'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN"
                ],
                "exact": true
              },
              {
                "name": "Account",
                "path": "/:org/:ws/account",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__AccountSettings' */'/codebuild/output/src3512736026/src/app/src/pages/AccountSettings'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              },
              {
                "name": "Catalog",
                "path": "/:org/:ws/catalog",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Catalog' */'/codebuild/output/src3512736026/src/app/src/pages/Catalog'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              },
              {
                "name": "Hub shared datasets",
                "path": "/:org/:ws/share/:workspaceId",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Hub__HubSharedDatasets' */'/codebuild/output/src3512736026/src/app/src/pages/Hub/HubSharedDatasets'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              },
              {
                "name": "Hub",
                "path": "/:org/:ws/hub/:folderId",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Hub' */'/codebuild/output/src3512736026/src/app/src/pages/Hub'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              },
              {
                "name": "Hub Root",
                "path": "/:org/:ws/hub",
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              },
              {
                "name": "Flows",
                "path": "/:org/:ws/flows",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Flows' */'/codebuild/output/src3512736026/src/app/src/pages/Flows'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              },
              {
                "name": "Members",
                "path": "/:org/:ws/members",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__WorkspaceMembers' */'/codebuild/output/src3512736026/src/app/src/pages/WorkspaceMembers'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN"
                ],
                "exact": true
              },
              {
                "name": "Monitor",
                "path": "/:org/:ws/monitor",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Monitor' */'/codebuild/output/src3512736026/src/app/src/pages/Monitor'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR"
                ],
                "exact": true
              },
              {
                "name": "Dashboard",
                "path": "/:org/:ws/dashboard",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dashboard' */'/codebuild/output/src3512736026/src/app/src/pages/Dashboard'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR",
                  "VIEWER"
                ],
                "exact": true
              },
              {
                "name": "View Integration",
                "path": "/:org/:ws/integrations/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Integrations__ViewIntegration' */'/codebuild/output/src3512736026/src/app/src/pages/Integrations/ViewIntegration'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN"
                ],
                "exact": true
              },
              {
                "name": "Integrations",
                "path": "/:org/:ws/integrations",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Integrations' */'/codebuild/output/src3512736026/src/app/src/pages/Integrations'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN"
                ],
                "exact": true
              },
              {
                "name": "Connections",
                "path": "/:org/:ws/connections",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__WorkspaceConnections' */'/codebuild/output/src3512736026/src/app/src/pages/WorkspaceConnections'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN"
                ],
                "exact": true
              },
              {
                "name": "Insights",
                "path": "/:org/:ws/assistant/:conversationId?",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Insights' */'/codebuild/output/src3512736026/src/app/src/pages/Insights'), loading: LoadingComponent}),
                "authority": [
                  "ADMIN",
                  "EDITOR",
                  "VIEWER"
                ],
                "exact": true
              },
              {
                "path": "/:org/:ws/insights",
                "redirect": "/:org/:ws/assistant",
                "exact": true
              },
              {
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/codebuild/output/src3512736026/src/app/src/pages/404'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/codebuild/output/src3512736026/src/app/src/pages/404'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "path": "/insights",
        "redirect": "/",
        "exact": true
      },
      {
        "path": "/catalog",
        "redirect": "/",
        "exact": true
      },
      {
        "path": "/hub",
        "redirect": "/",
        "exact": true
      },
      {
        "path": "/share",
        "redirect": "/",
        "exact": true
      },
      {
        "path": "/flows",
        "redirect": "/",
        "exact": true
      },
      {
        "path": "/monitor",
        "redirect": "/",
        "exact": true
      },
      {
        "path": "/members",
        "redirect": "/",
        "exact": true
      },
      {
        "path": "/connections",
        "redirect": "/",
        "exact": true
      },
      {
        "path": "/integrations",
        "redirect": "/",
        "exact": true
      },
      {
        "path": "/settings",
        "redirect": "/",
        "exact": true
      },
      {
        "path": "/account",
        "redirect": "/",
        "exact": true
      },
      {
        "path": "/",
        "redirect": "/login-success",
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/codebuild/output/src3512736026/src/app/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
